<div [@layoutChanged]="prepareRoute(outlet)">
	<router-outlet #outlet="outlet"></router-outlet>
</div>